import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

import { Required } from 'package-utils';

import { OptionLabelDirective } from '../../directives/option-label.directive';
import { OptionValueDirective } from '../../directives/option-value.directive';

import { DisplaySwitch } from '../../interfaces/offer-management';

@Component({
  selector: 'app-display-option-select',
  templateUrl: './display-option-select.component.html',
  styleUrls: ['./display-option-select.component.scss', '../../styles/option-button.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisplayOptionSelectComponent<T> {
  @Required @Input() selection!: T;
  @Input() labelWidth = '';
  @Input() options: DisplaySwitch<T>[] = [];

  @Output() selectionChange = new EventEmitter<T>();

  @ContentChild(OptionLabelDirective, { read: TemplateRef, static: true }) label!: TemplateRef<any>;
  @ContentChild(OptionValueDirective, { read: TemplateRef, static: true }) value!: TemplateRef<any>;

  pickSelected<T>(val: T, displaySwitch: DisplaySwitch<T>[]): DisplaySwitch<T> | undefined {
    return displaySwitch.find(({ value }) => value === val);
  }
}
